import * as types from './supplierActionTypes';

export const getSupplierRequest = (payload) => 
({ type: types.GET_SUPPLIER_REQUEST, payload });
export const getSupplierSuccess = (payload) => 
({ type: types.GET_SUPPLIER_SUCCESS, payload });
export const getSupplierError = (payload) => 
({ type: types.GET_SUPPLIER_ERROR, payload });

export const addSupplierRequest = (payload) => 
({ type: types.ADD_SUPPLIER_REQUEST, payload });
export const addSupplierSuccess = (payload) => 
({ type: types.ADD_SUPPLIER_SUCCESS, payload });
export const addSupplierError = (payload) => 
({ type: types.ADD_SUPPLIER_ERROR, payload });

export const updateSupplierRequest = (payload) => 
({ type: types.UPDATE_SUPPLIER_REQUEST, payload });
export const updateSupplierSuccess = (payload) => 
({ type: types.UPDATE_SUPPLIER_SUCCESS, payload });
export const updateSupplierError = (payload) => 
({ type: types.UPDATE_SUPPLIER_ERROR, payload });

export const deleteSupplierRequest = (payload) => 
({ type: types.DELETE_SUPPLIER_REQUEST, payload });
export const deleteSupplierSuccess = (payload) => 
({ type: types.DELETE_SUPPLIER_SUCCESS, payload });
export const deleteSupplierError = (payload) => 
({ type: types.DELETE_SUPPLIER_ERROR, payload }); 